<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

@if (!isMfd) {
  <div class="modal-header">
    <h5 class="modal-title" [xdaTranslate]="'SDE_COUNTRY_CODE'"></h5>
  </div>
}
@if (isMfd) {
  <div class="mfd">
    <div class="action-bar clear">
      <div class="left">
        <button
          type="button"
          class="xrx-btn btn-secondary btn medium glyph xgl-close mfd"
          data-dismiss="modal"
          aria-label="Close"
          (click)="activeModal.dismiss()">
          <span aria-hidden="true" class="xgl-close"></span>
        </button>
      </div>
      <div class="right">
        <button
          class="xrx-btn btn-secondary btn medium glyph xgl-checkmark"
          type="button"
          (click)="activeModal.close(selected)">
          <span class="btn-label text-medium" xdaTranslate>SDE_OK</span>
        </button>
      </div>
      <div class="middle">
        <span
          class="title text-x-large"
          [xdaTranslate]="'SDE_COUNTRY_CODE'"></span>
      </div>
    </div>
  </div>
}

<div class="modal-body" [ngClass]="{ 'p-0': !isMfd }" tabindex="-1">
  <div class="search-wrapper" [ngClass]="{ mfd: isMfd }">
    @if (!isMfd) {
      <p class="title" [xdaTranslate]="'SDE_SEARCH_COUNTRY'"></p>
    }
    <div
      class="search-group"
      [ngClass]="{
        'input-group': !isMfd,
        'input-group-is-invalid': !searchIsValid,
      }">
      <input
        id="countrySearch"
        [(ngModel)]="searchTerm"
        name="countrySearch"
        type="text"
        maxlength="32"
        class="form-control search-term"
        [ngClass]="{ 'textField medium': isMfd, 'web-portal': !isMfd }"
        (keyup)="validateSearch($event)"
        (blur)="validateSearch($event)"
        [placeholder]="searchPlaceholder"
        [minlength]="searchMinLength" />
      @if (showClearSearch) {
        <div [ngClass]="{ 'input-group-append': !isMfd }">
          <button
            (click)="clearSearch()"
            type="button"
            class="xrx-btn btn-short btn-primary xgl-clear_all"
            [ngClass]="{ mfd: isMfd }"
            [ngbTooltip]="clearTooltip"
            [disableTooltip]="isMfd"></button>
        </div>
      }
    </div>
    <div
      class="invalid-feedback"
      [ngClass]="{ 'd-block': !searchIsValid }"
      [xdaTranslate]="'SDE_ENTERT_LEAST_2'"
      [formatValues]="searchMinLength.toString()"></div>
  </div>
  <p
    class="title"
    [ngClass]="{ 'mfd text-small': isMfd }"
    [xdaTranslate]="'SDE_SELECT_COUNTRY_INSERT'"></p>
  @if (!isMfd) {
    <table
      class="table table-sort table-hover"
      [ngClass]="{ 'mfd text-medium': isMfd, 'table-sm': !isMfd }">
      @if (!isMfd) {
        <thead>
          <tr>
            <th
              sortableCol="keyTranslated"
              direction="asc"
              [initialSort]="true"
              (sort)="setSortParams($event)"
              scope="col"
              class="sort-active user-name">
              <span xdaTranslate>SDE_COUNTRY</span>
            </th>
            <th
              sortableCol="value"
              direction="asc"
              sorttype="number"
              (sort)="setSortParams($event)"
              scope="col"
              class="sort-active user-name">
              <span xdaTranslate>SDE_CODE</span>
            </th>
          </tr>
        </thead>
      }
      <tbody>
        @for (
          country of countries
            | tableFilter: searchTerm : ['keyTranslated'] : searchMinLength
            | tableSort: direction : column : type;
          track country;
          let i = $index;
          let last = $last;
          let first = $first
        ) {
          <tr
            (click)="rowClicked(country)"
            [ngClass]="{ selected: country.selected }">
            <td>{{ country.keyTranslated }}</td>
            <td>{{ country.value }}</td>
          </tr>
        }
        <tr class="no-results">
          <td
            class="text-center"
            colspan="2"
            [xdaTranslate]="'SDE_NO_SEARCH_RESULTS2'"></td>
        </tr>
      </tbody>
    </table>
  }
  @if (isMfd) {
    <div class="form-group mfd scroll-content {{ scrollClass }}">
      @for (
        country of countries
          | tableFilter: searchTerm : ['keyTranslated'] : searchMinLength
          | tableSort: direction : column : type;
        track country;
        let i = $index;
        let last = $last;
        let first = $first
      ) {
        <div
          class="form-control country text-medium d-flex"
          (click)="rowClicked(country)"
          [ngClass]="{ selected: country.selected }">
          <span>{{ country.keyTranslated }}</span>
          <span>{{ country.value }}</span>
        </div>
      }
      <span
        class="form-control text-medium no-results"
        [xdaTranslate]="'SDE_NO_SEARCH_RESULTS2'"></span>
    </div>
  }
</div>
@if (!isMfd) {
  <div class="modal-footer">
    <div class="cb d-flex flex-column">
      <button
        type="button"
        class="xrx-btn btn-secondary"
        (click)="activeModal.close()">
        <span class="btn-label" [xdaTranslate]="'SDE_CANCEL'"></span>
      </button>
      <button
        type="button"
        class="xrx-btn btn-primary mt-3"
        (click)="activeModal.close(selected)"
        [disabled]="!selected">
        <span class="btn-label" [xdaTranslate]="'SDE_OK'"></span>
      </button>
    </div>
  </div>
}
